interface AssignableClassroom {
  assignOnJoin?: boolean;
  assignedStudentCount: string | number;
}

export function assignedClassrooms<T extends AssignableClassroom>(classrooms: T[]): T[] {
  return classrooms.filter(c => Boolean(c.assignOnJoin) || Number(c.assignedStudentCount) > 0)
}
